var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.item
    ? _c(
        "el-dialog",
        {
          staticClass: "d-look-voucher-dialog",
          attrs: {
            title: "强制签退凭证",
            visible: _vm.visible,
            width: "600px",
            "before-close": _vm.onCloseEvent
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "c-title-row" }, [
            _c("p", { staticClass: "c-title-text" }, [_vm._v("拍照方式:")]),
            _c("p", { staticClass: "c-title-text-span" }, [
              _vm._v(_vm._s(_vm.formatterCellValue(_vm.item.photoName)))
            ])
          ]),
          _c("div", { staticClass: "c-title-row c-title-text-margin" }, [
            _c("p", { staticClass: "c-title-text" }, [_vm._v("操作人:")]),
            _c("p", { staticClass: "c-title-text-span" }, [
              _vm._v(_vm._s(_vm.formatterCellValue(_vm.item.operationRealName)))
            ])
          ]),
          _c("div", { staticClass: "c-title-row c-title-text-margin" }, [
            _c("p", { staticClass: "c-title-text" }, [_vm._v("操作时间:")]),
            _c("p", { staticClass: "c-title-text-span" }, [
              _vm._v(_vm._s(_vm.formatterCellValue(_vm.item.operationTime)))
            ])
          ]),
          _c("div", { staticClass: "c-title-row c-title-text-margin" }, [
            _c("p", { staticClass: "c-title-text" }, [_vm._v("说明:")]),
            _c("p", { staticClass: "c-title-text-span" }, [
              _vm._v(
                _vm._s(_vm.formatterCellValue(_vm.item.operationDescription))
              )
            ])
          ]),
          _c(
            "div",
            { staticClass: "c-title-row c-title-text-margin" },
            [
              _c("p", { staticClass: "c-title-text" }, [_vm._v("凭证:")]),
              _vm.item.prefixValidFaceUrl &&
              _vm.item.prefixValidFaceUrl.length > 0
                ? _c("el-image", {
                    staticClass: "c-title-image",
                    attrs: {
                      fit: "cover",
                      src: _vm.item.prefixValidFaceUrl,
                      "preview-src-list": [_vm.item.prefixValidFaceUrl]
                    }
                  })
                : _c("span", [_vm._v("无")])
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { slot: "footer", size: "medium", type: "primary" },
              on: { click: _vm.onCloseEvent },
              slot: "footer"
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }